const mapBackgroundToContentColor = ({ backgroundColor, theme, }) => {
    const textColor = theme.colors.maps.backgroundToContent[backgroundColor];
    return (theme.colors.content[textColor] ||
        theme.colors.content.primary);
};
const mapContentToBackgroundColor = ({ contentColor, theme, }) => {
    const backgroundColor = theme.colors.maps.contentToBackground[contentColor];
    return theme.colors.background[backgroundColor];
};

export { mapBackgroundToContentColor, mapContentToBackgroundColor };
